import React, { Component } from 'react';
import PrismicReact from 'prismic-reactjs';

import PageContent from './PageContent';
import NotFound from './NotFound';
import Loader from './Loader';
import Navbar from './Navbar';
import Footer from './Footer';
import Top from './Top';

import '../style/Page.css';

export default class Page extends Component {
  state = {
    doc: null,
    notFound: false,
  }

  componentWillMount() {
    this.fetchPage(this.props);
  }

  componentWillReceiveProps(props) {
    this.fetchPage(props);
  }

  componentDidUpdate() {
    this.props.prismicCtx.toolbar();
  }

  fetchPage(props) {
		const { uid } = props.match.params;
		const { prismicCtx } = props;

    if (prismicCtx) {
      return prismicCtx.api.getByUID('page', uid ? uid : 'home', {}, (err, doc) => {
        if (doc) {
          this.setState({ doc });
        } else {
          this.setState({ notFound: !doc });
        }
      });
    }
    return null;
  }

	render() {
	  if (this.state.doc) {
	    return (
				<div className="page">
					<Top />
					<Navbar prismicCtx={this.props.prismicCtx} />
					<PageContent
						PrismicReact={PrismicReact}
						prismicCtx={this.props.prismicCtx}
						data={this.state.doc.data}
					/>
					<Footer prismicCtx={this.props.prismicCtx} />
				</div>
	    );
	  } else if (this.state.notFound) {
	    return <NotFound />;
	  }

	  return (
			<Loader />
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Page.js